export function getCssClasses(section, layout, reviewStatus) {
  var cssClasses = ''

  if (section === layout) {
    cssClasses += 'active'
  }
  if (layout === 'questreview') {
    cssClasses += ` ${reviewStatus}`
  }
  if (layout === 'questhistory') {
    cssClasses += ' questhistory'
  }
  return cssClasses
}

export function isRequiredSection(layout) {
  return [
    'basicinformation',
    'activities',
    'images',
    'otherinformation'
  ].includes(layout)
}

export function getSectionCommentCount(comments, layout) {
  return comments.filter(function (comment) {
    // status 0 means it is not marked resolved
    return comment.section === layout && comment.status === 0
  }).length
}

export function hasSectionDraftComments(comments, layout) {
  return (
    comments.filter(function (comment) {
      return comment.section === layout
    }).length > 0
  )
}

export function hasActivityDraftComments(comments, activity) {
  return (
    comments.filter(function (comment) {
      return comment.resource_id === activity.id
    }).length > 0
  )
}

export function getActivityCommentCount(comments, activity) {
  return comments.filter(function (comment) {
    // status 0 means it is not marked resolved
    return comment.resource_id === activity.id && comment.status === 0
  }).length
}



// WEBPACK FOOTER //
// ./src/utils/questmenuitem.js